import { Component, OnInit, Input, DoCheck, Optional, Output, EventEmitter } from '@angular/core';
import { FormControl, Validators, FormGroup, AbstractControl, AsyncValidatorFn, ControlContainer, FormGroupDirective } from '@angular/forms';
import { ErrorMassageValidation } from '../../Shared/services/validationErrorMassage.service';
import { InputType } from '../../Shared/Enums/InputType';
import { UtilityService } from '../../Shared/services/UtilityService';
import { EnglishArabicDTO } from '../../Shared/Models/EnglishArabicDTO';
import { MultiLingualTextAreaOptions } from '../../Shared/Models/MultiLingualTextAreaOptions';
import { ControlUtility } from '../../Shared/services/ControlUtility';
import { LangChangeEvent } from '@ngx-translate/core';
import { LanguageMode } from '../../Shared/Enums/LanguageMode';


@Component({
  selector: 'BBSF-MultiLingualTextArea',
  templateUrl: './MultiLingualTextArea.component.html',
  styleUrls: ['./MultiLingualTextArea.component.scss']
})
export class MultiLingualTextAreaComponent implements OnInit {

  static controlContainerstatic = null;
  constructor(private ErrorHandler: ErrorMassageValidation, public MultiLingualTextAreaFormControlHost: FormGroupDirective, @Optional() private controlContainer: ControlContainer, private controlUtility: ControlUtility
  ) {
    MultiLingualTextAreaComponent.controlContainerstatic = this.controlContainer;
  }
  @Input() group: FormGroup;
  @Input() options: MultiLingualTextAreaOptions;
  @Output() OnChange = new EventEmitter();

  ArabicTextAreaFormControl: AbstractControl;
  EnglishTextAreaFormControl: AbstractControl;
  MultiTextAreaFormControl: AbstractControl;
  MultiLanguageTextAreagroup: FormGroup;
  ArabicWordCount: number = 0;
  ArabicWordCountArray: number = 0;
  EnglishWordCount: number = 0;
  EnglishWordCountArray: number = 0;
  CurrentLanguage: string = "";
  ShowArabicTextArea: boolean
  ShowEngishTextArea: boolean
  ArabicValidationRules = [];
  ArabicValidationRulesasync = [];
  EnglishValidationRules = [];
  EnglishValidationRulesasync = [];
  validationRules = [];
  validationRulesasync = [];
  IsShowArabicWordCount: boolean = false;
  IsShowEnglishWordCount: boolean = false;
  markAllAsTouched: boolean = false;

  ngOnInit() {
    UtilityService.isCreatedBefor = false
    this.CurrentLanguage = UtilityService.CurrentLanguage;
    UtilityService.Translator.onLangChange.subscribe((event: LangChangeEvent) => {
      this.CurrentLanguage = event.lang
      this.showInputUsingLanguageMode();

    });

    if (this.options.ArabicLabelKey != null && this.options.ArabicLabelKey != "")
      this.options.ArabicLabelValue = UtilityService.getResourceValue(this.options.ArabicLabelKey);

    if (this.options.EnglishLabelKey != null && this.options.EnglishLabelKey != "")
      this.options.EnglishLabelValue = UtilityService.getResourceValue(this.options.EnglishLabelKey);

    this.MultiLanguageTextAreagroup = new FormGroup({});
    this.MultiLanguageTextAreagroup.addControl("ArabicTextAreaValue", new FormControl(''));
    this.MultiLanguageTextAreagroup.addControl("EnglishTextAreaValue", new FormControl(''));
    this.ArabicTextAreaFormControl = this.MultiLanguageTextAreagroup.controls["ArabicTextAreaValue"]; //  new FormControl('',validationRules);
    this.EnglishTextAreaFormControl = this.MultiLanguageTextAreagroup.controls["EnglishTextAreaValue"]; //  new FormControl('',validationRules);
    this.group.addControl(this.options.Name, new FormGroup(this.MultiLanguageTextAreagroup.controls));

    switch (this.options.Type) {
      case InputType.Email:
        this.EnglishValidationRules.push(Validators.compose([
          this.controlUtility.patternValidator(/^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$/, { EmailValidationKey: "" }),

        ]));
        this.ArabicValidationRules.push(Validators.compose([
          this.controlUtility.patternValidator(/^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$/, { EmailValidationKey: "" }),

        ]));
        break;

      case InputType.Number:
        this.EnglishValidationRules.push(Validators.pattern('^[0-9]+(\.?[0-9]+)?$'));
        this.ArabicValidationRules.push(Validators.pattern('^[0-9]+(\.?[0-9]+)?$'));
        break;
    }



    if (this.options.CustomValidation.length > 0) {
      let Validations = this.options.CustomValidation
      for (let index = 0; index < Validations.length; index++) {
        const Validation = Validations[index];
        this.EnglishValidationRules.push(Validation.functionBody);
        this.ArabicValidationRules.push(Validation.functionBody);
      }

    }

    if (this.options.MinLength > 0) {
      this.ArabicValidationRules.push(Validators.minLength(this.options.MinLength));
      this.EnglishValidationRules.push(Validators.minLength(this.options.MinLength));
    }
    if (this.options.MaxLength > 0) {
      this.EnglishValidationRules.push(Validators.maxLength(this.options.MaxLength));
      this.ArabicValidationRules.push(Validators.maxLength(this.options.MaxLength));

    }

    this.showInputUsingLanguageMode();
    this.ArabicTextAreaFormControl.setValidators(this.ArabicValidationRules);
    this.ArabicTextAreaFormControl.setAsyncValidators(this.ArabicValidationRulesasync);
    this.EnglishTextAreaFormControl.setValidators(this.EnglishValidationRules);
    this.EnglishTextAreaFormControl.setAsyncValidators(this.EnglishValidationRulesasync);


    if (this.options.IsDisabled) {
      this.EnglishTextAreaFormControl.disable();
      this.ArabicTextAreaFormControl.disable();
    }
    this.ArabicTextAreaFormControl.setValue(this.options.Value.Arabic)
    this.EnglishTextAreaFormControl.setValue(this.options.Value.English)

    this.MultiLingualTextAreaFormControlHost.ngSubmit.subscribe((value) => {
      this.group.markAllAsTouched()
      this.markAllAsTouched = true
    })

  }


  onTextChange() {
    let arabicValue = this.MultiLanguageTextAreagroup.controls["ArabicTextAreaValue"].value == null ? "" : this.MultiLanguageTextAreagroup.controls["ArabicTextAreaValue"].value;
    let englishValue = this.MultiLanguageTextAreagroup.controls["EnglishTextAreaValue"].value == null ? "" : this.MultiLanguageTextAreagroup.controls["EnglishTextAreaValue"].value;
    if (this.EnglishTextAreaFormControl.value == "") {
      this.EnglishWordCountArray = 0;
      this.EnglishWordCount = 0;
    }
    else {
      if (this.EnglishTextAreaFormControl.value != null || this.EnglishTextAreaFormControl.value != undefined) {
        this.EnglishWordCountArray = this.EnglishTextAreaFormControl.value.split(" ").length;
        if (this.EnglishWordCountArray > 0) {
          if (this.EnglishWordCountArray > this.options.MaxWordCount) {
            this.EnglishWordCount = this.options.MaxWordCount;
            this.MultiLanguageTextAreagroup.controls["EnglishTextAreaValue"].setErrors({ MaxWordCountValidationKey: this.options.MaxWordCount });
            this.MultiLanguageTextAreagroup.controls["EnglishTextAreaValue"].markAsTouched();
            this.MultiLanguageTextAreagroup.controls["EnglishTextAreaValue"].invalid;
          }
          else {
            this.EnglishWordCount = this.EnglishWordCountArray;
          }
        }
      }

    }
    if (this.ArabicTextAreaFormControl.value == "") {
      this.ArabicWordCountArray = 0;
      this.ArabicWordCount = 0;
    }
    else {
      if (this.ArabicTextAreaFormControl.value != null || this.ArabicTextAreaFormControl.value != undefined) {
        this.ArabicWordCountArray = this.ArabicTextAreaFormControl.value.split(" ").length;
        if (this.ArabicWordCountArray > 0) {
          if (this.ArabicWordCountArray > this.options.MaxWordCount) {
            this.ArabicWordCount = this.options.MaxWordCount;
            this.MultiLanguageTextAreagroup.controls["ArabicTextAreaValue"].setErrors({ MaxWordCountValidationKey: this.options.MaxWordCount });
            this.MultiLanguageTextAreagroup.controls["ArabicTextAreaValue"].markAsTouched();
            this.MultiLanguageTextAreagroup.controls["ArabicTextAreaValue"].invalid;
          }
          else {
            this.ArabicWordCount = this.ArabicWordCountArray;
          }
        }
      }

    }
    let mulitLangModel = new EnglishArabicDTO();
    mulitLangModel.Arabic = arabicValue;
    mulitLangModel.English = englishValue;
    this.ArabicTextAreaFormControl = arabicValue;
    this.EnglishTextAreaFormControl = englishValue;
    this.OnChange.emit(mulitLangModel)
    this.group.get(this.options.Name).setValue(mulitLangModel);
  }

  resetError = () => {
    UtilityService.RemoveGlobalError();
  }



  showGlobalError() {
    this.controlUtility.showGlobalError()
  }

  getErrorValidation(ErrorList) {
    if (this.markAllAsTouched && this.group.invalid) {
      this.showGlobalError()
      this.markAllAsTouched = false
    }
    return this.controlUtility.getErrorValidationMassage(ErrorList, this.group, this.options);
  }

  getInputType(type: number) {
    return InputType[type]
  }

  trimControlValue(type: string) {
    const whitespace: string = ' ';
    if (type == "En") {
      if (this.EnglishTextAreaFormControl.value.startsWith(whitespace) || this.EnglishTextAreaFormControl.value.endsWith(whitespace)) {
        this.EnglishTextAreaFormControl.patchValue(this.EnglishTextAreaFormControl.value.trim());
      }
    }
    if (type == "Ar") {
      if (this.ArabicTextAreaFormControl.value.startsWith(whitespace) || this.ArabicTextAreaFormControl.value.endsWith(whitespace)) {
        this.ArabicTextAreaFormControl.patchValue(this.ArabicTextAreaFormControl.value.trim());

      }
    }

  }

  copyInputMessage(inputElement) {
    this.controlUtility.CopyInputMessage(inputElement)
  }


  showInputUsingLanguageMode() {

    this.ArabicValidationRules = this.ArabicValidationRules.filter(item => item !== Validators.required);
    this.EnglishValidationRules = this.EnglishValidationRules.filter(item => item !== Validators.required);

    this.ArabicTextAreaFormControl.clearValidators();
    this.EnglishTextAreaFormControl.clearValidators();

    this.ArabicTextAreaFormControl.updateValueAndValidity();
    this.EnglishTextAreaFormControl.updateValueAndValidity();

    switch (this.options.LanguageMode) {
      case LanguageMode.Both_Languages_are_visible:
        this.ShowArabicTextArea = true;
        this.ShowEngishTextArea = true;
        if (this.options.IsRequired == true) {
          this.EnglishValidationRules.push(Validators.required);
          this.ArabicValidationRules.push(Validators.required);

        }
        break;
      case LanguageMode.Arabic_Language_only_is_visible:
        this.ShowArabicTextArea = true;
        break;
      case LanguageMode.English_Language_only_is_visible:
        this.ShowEngishTextArea = true;
        break;
      case LanguageMode.Both_Languages_are_visible_but_only_current_language_is_required:
        this.ShowArabicTextArea = true;
        this.ShowEngishTextArea = true;

        if (this.CurrentLanguage == 'ar') {
          if (this.options.IsRequired == true) {
            this.ArabicValidationRules.push(Validators.required);

          }
        }
        if (this.CurrentLanguage == 'en') {
          if (this.options.IsRequired == true) {
            this.EnglishValidationRules.push(Validators.required);


          }
        }
        break;
      case LanguageMode.Both_Languages_but_only_Arabic_is_required:
        this.ShowArabicTextArea = true;
        this.ShowEngishTextArea = true;
        if (this.options.IsRequired == true) {
          this.ArabicValidationRules.push(Validators.required);

        }
        break;
      case LanguageMode.Both_Languages_but_only_English_is_required:
        this.ShowArabicTextArea = true;
        this.ShowEngishTextArea = true;
        if (this.options.IsRequired == true) {
          this.EnglishValidationRules.push(Validators.required);

        }
        break;
      case LanguageMode.Current_Language_only_is_visible_and_required:
        if (this.CurrentLanguage == 'ar') {
          this.ShowArabicTextArea = true;
          this.ShowEngishTextArea = false;
          if (this.options.IsRequired == true) {
            this.ArabicValidationRules.push(Validators.required);

          }
        }
        if (this.CurrentLanguage == 'en') {
          this.ShowArabicTextArea = false;
          this.ShowEngishTextArea = true;
          if (this.options.IsRequired == true) {
            this.EnglishValidationRules.push(Validators.required);

          }
        }
        break;
      default:
        break;
    }

    this.ArabicTextAreaFormControl.setValidators(this.ArabicValidationRules);
    this.EnglishTextAreaFormControl.setValidators(this.EnglishValidationRules);
    this.ArabicTextAreaFormControl.updateValueAndValidity();
    this.EnglishTextAreaFormControl.updateValueAndValidity();
  }


  showArabicWordCount(value: boolean) {
    this.IsShowArabicWordCount = value
  }

  showEnglishWordCount(value: boolean) {
    this.IsShowEnglishWordCount = value
  }

  //External Method
  RemoveRequiredValidation = () => {
    this.controlUtility.RemoveRequiredValidation(this.EnglishTextAreaFormControl, this.EnglishValidationRules, this.options)
    this.controlUtility.RemoveRequiredValidation(this.ArabicTextAreaFormControl, this.ArabicValidationRules, this.options)
  }
  //External Method
  AddRequiredValidation = () => {
    this.controlUtility.AddRequiredValidation(this.EnglishTextAreaFormControl, this.EnglishValidationRules, this.options)
    this.controlUtility.AddRequiredValidation(this.ArabicTextAreaFormControl, this.ArabicValidationRules, this.options)
  }


  //External Method
  RemoveCustomValidation = (CustomValidation) => {
    this.controlUtility.RemoveCustomValidation(this.EnglishTextAreaFormControl, this.EnglishValidationRules, CustomValidation)
    this.controlUtility.RemoveCustomValidation(this.ArabicTextAreaFormControl, this.ArabicValidationRules, CustomValidation)
  }
  //External Method
  AddCustomValidation = (CustomValidation) => {
    this.controlUtility.AddCustomValidation(this.EnglishTextAreaFormControl, this.EnglishValidationRules, CustomValidation)
    this.controlUtility.AddCustomValidation(this.ArabicTextAreaFormControl, this.ArabicValidationRules, CustomValidation)
  }
  //External Method
  IsValid = () => {
    this.controlUtility.IsValid(this.EnglishTextAreaFormControl)
    this.controlUtility.IsValid(this.ArabicTextAreaFormControl)
  }

}

